var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Components
import { Label } from '../../../atoms/Label';
// Utils
import { css } from 'styled-components';
// Types
import { TableHeaderStylePropertiesByVariant, } from '../../../common/types/TableHeaderStylePropertiesByVariant';
export var getTableHeaderStylesByVariant = function (styleVariant) {
    if (styleVariant === void 0) { styleVariant = 'textLeftAlign'; }
    var textAlign = TableHeaderStylePropertiesByVariant[styleVariant]().textAlign;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", " {\n      text-align: ", ";\n    }\n  "], ["\n    ", " {\n      text-align: ", ";\n    }\n  "])), Label, textAlign);
};
var templateObject_1;
//# sourceMappingURL=getTableHeaderStylesByVariant.js.map